import React, { useState } from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

import CustomTooltip from "./components/Tooltip";
import loader from "../../images/loader-dots.svg";
import { METRIC_TYPES } from "../../constants/global";
import { formatXAxis, getYDomain, formatPercentTick } from "../../helpers/metrics";

const Chart = ({ chartData, isLoading, type }) => {
  const [tooltipData, setTooltipData] = useState({ index: -1, data: [], keys: [] });

  const onActiveDot = (dot) => {
    if (tooltipData.index === dot.index) {
      if (!tooltipData.keys.includes(dot.dataKey)) {
        setTooltipData({
          ...tooltipData,
          data: [...tooltipData.data, dot.payload],
          keys: [...tooltipData.keys, dot.dataKey]
        });
      }
    } else {
      setTooltipData({ index: dot.index, data: [dot.payload], keys: [dot.dataKey] });
    }
  };

  const renderLines = (chartData) => {
    return chartData.map((chart, index) => {
      const chartValue = chart[0];
      return (
        <Line
          key={index}
          name={chartValue.name}
          xAxisId={chartValue.type}
          type="linear"
          strokeWidth={2}
          dataKey={chartValue.type}
          data={chart}
          stroke={chartValue.color}
          dot={false}
          activeDot={onActiveDot}
        />
      );
    });
  };

  const renderAxis = (chartData) => {
    return chartData.map((chart, index) => {
      const chartValue = chart[0];
      return (
        <XAxis
          key={index}
          dataKey="amt"
          xAxisId={chartValue.type}
          reversed={true}
          tickFormatter={formatXAxis}
          scale="time"
          hide={chartValue.type !== "uo"}
        />
      );
    });
  };

  return (
    <ResponsiveContainer width="100%" height={400}>
      {isLoading ? (
        <img alt="loader" src={loader} style={{ width: 50, margin: "0 47%" }} />
      ) : (
        <LineChart
          width={500}
          height={400}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          {renderAxis(chartData)}
          {type === METRIC_TYPES.REQUEST_LATENCY ? (
            <YAxis orientation="right" domain={getYDomain(chartData)} />
          ) : (
            <YAxis orientation="right" ticks={[0, 50, 100, 150]} tickFormatter={formatPercentTick} />
          )}
          <Tooltip content={<CustomTooltip tooltipData={tooltipData} type={type} />} />
          <Legend />
          {renderLines(chartData)}
        </LineChart>
      )}
    </ResponsiveContainer>
  );
};

export { Chart };
